import {Button} from '@dropbox/dig-components/buttons';
import {Text} from '@dropbox/dig-components/typography';
import React from 'react';
import {ANALYTICS_EVENTS, sendAnalyticsEvent} from 'utilities/analytics';

import styles from './Layout.module.css';

const HelpfulPoll = () => {
  const [isOpen, setIsOpen] = React.useState(true);
  // Key to use for localStorage
  // Check if we should suppress the poll based on previous dismissal
  const pageRoute = window.location.pathname;
  const routeKey = pageRoute.replace('/', '_');
  const POLL_LOCALSTORAGE_KEY = `spritesGptHelpfulPollLastClosed${routeKey}`;
  React.useEffect(() => {
    // Only run this check on mount
    const lastClosed = localStorage.getItem(POLL_LOCALSTORAGE_KEY);
    if (lastClosed) {
      const lastClosedTime = parseInt(lastClosed, 10);
      const timeToDismiss = 7 * 24 * 60 * 60 * 1000; // one week in ms
      const now = Date.now();
      if (now - lastClosedTime < timeToDismiss) {
        // Dismiss poll (hide it)
        setIsOpen(false);
      }
    }
  }, [POLL_LOCALSTORAGE_KEY]);

  if (!isOpen) {
    return null;
  }

  // When poll is closed (by button), set localStorage to mark when it was closed
  const handleWasHelpful = (value: boolean) => {
    localStorage.setItem(POLL_LOCALSTORAGE_KEY, Date.now().toString());
    let eventAction: string;
    let label: string;

    switch (pageRoute) {
      case '/feedback':
        eventAction = value
          ? ANALYTICS_EVENTS.MODULE_FEEDBACK.FEEDBACK_ASSISTANT_HELPFUL
          : ANALYTICS_EVENTS.MODULE_FEEDBACK.FEEDBACK_ASSISTANT_NOT_HELPFUL;
        label = 'Feedback Assistant Chat';
        break;
      case '/manager_feedback':
        eventAction = value
          ? ANALYTICS_EVENTS.MODULE_FEEDBACK.MANAGER_ASSISTANT_HELPFUL
          : ANALYTICS_EVENTS.MODULE_FEEDBACK.MANAGER_ASSISTANT_NOT_HELPFUL;
        label = 'Manager Assistant';
        break;
      case '/career_framework':
        eventAction = value
          ? ANALYTICS_EVENTS.MODULE_FEEDBACK.CAREER_FRAMEWORKS_HELPFUL
          : ANALYTICS_EVENTS.MODULE_FEEDBACK.CAREER_FRAMEWORKS_NOT_HELPFUL;
        label = 'Career Frameworks';
        break;
      default:
        return;
    }

    sendAnalyticsEvent(eventAction, {
      category: 'Module Feedback',
      label: label,
    });

    setIsOpen(false);
  };

  return (
    <div
      className={`${styles['helpful-poll']}`}
      style={{
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? 'translateY(0)' : 'translateY(10px)',
      }}
    >
      <Text>Was this Module helpful?</Text>
      <Button onClick={() => handleWasHelpful(true)} variant="filled">
        Yes
      </Button>
      <Button onClick={() => handleWasHelpful(false)} variant="filled">
        No
      </Button>
    </div>
  );
};

export {HelpfulPoll};
